import React from 'react';
import { compose } from 'recompose';
import { withCalendar, withAppointmentDraggable } from '../CalendarContext';
import CardAppointmentDay from './CardAppointmentDay';

export default compose(
  withAppointmentDraggable,
  withCalendar
)(CardAppointmentDay);
